/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ObservableCollection$1 } from "igniteui-react-core";
import { Button } from "./Button";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var ButtonGroupButtonCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ButtonGroupButtonCollection, _super);
    function ButtonGroupButtonCollection() {
        var _this = _super.call(this, Button.$, 0) || this;
        _this.collectionResetting = null;
        return _this;
    }
    ButtonGroupButtonCollection.prototype.p = function () {
        if (this.collectionResetting != null) {
            this.collectionResetting(this, null);
        }
        _super.prototype.p.call(this);
    };
    ButtonGroupButtonCollection.$t = markType(ButtonGroupButtonCollection, 'ButtonGroupButtonCollection', ObservableCollection$1.$.specialize(Button.$));
    return ButtonGroupButtonCollection;
}(ObservableCollection$1));
export { ButtonGroupButtonCollection };
//# sourceMappingURL=ButtonGroupButtonCollection.js.map
